module.exports = __webpack_public_path__ + "img/ic_tilde.ff001369.svg";